<h2 mat-dialog-title class="release-header">
    <div class="d-flex align-items-center">
        <mat-icon class="mr-10">rocket_launch</mat-icon>
        <span>What's New</span>
    </div>
</h2>
<mat-dialog-content>
    <mat-card>
        <mat-card-content>
            <kendo-editor
                class="release-editor"
                [value]="compiledNotes"
                [readonly]="true"
                [iframe]="false"></kendo-editor>
        </mat-card-content>
    </mat-card>
</mat-dialog-content>
<mat-dialog-actions class="d-flex justify-content-center">
    <div class="col flex-wrap">
        @if (!userOpened && false) {
            <div class="col align-items-center">
                <mat-checkbox [formControl]="dontShowAgain">Don't show again</mat-checkbox>
            </div>
        }
        <div class="d-flex col justify-content-center align-items-end">
            <button class="col text-center" mat-raised-button color="primary" (click)="close()">Got it!</button>
        </div>
    </div>
</mat-dialog-actions>
